import http from '../clients/Axios'

export default class PurchaseOrderService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          if (el === 'pr_no') {
            filters_param =
              filters_param + '&' + el + '=' + filters[el].value.trim()
          } else {
            filters_param = filters_param + '&' + el + '=' + filters[el].value
          }
        }
      })
    }

    const res = await http.get(
      `/purchase/paginate?page=${pageNumber}&size=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get() {
    const res = await http.get('/purchase')
    return res
  }

  async getItemPO(param) {
    param = param ? param : ''
    const res = await http.get(`/purchase${param}`)
    return res
  }

  async getBy(param) {
    param = param ? param : ''
    const res = await http.get(`/purchase/receive${param}`)
    return res
  }

  async getById(param) {
    param = param ? param : ''
    const res = await http.get(`/purchase/${param}`)
    return res
  }

  async add(form) {
    const res = await http.post('/purchase', form)
    return res
  }

  async update(id, form) {
    const res = await http.put(`/purchase/${id}`, form)
    return res
  }

  async delete(purchase) {
    const res = await http.delete(`/purchase/${purchase}`)
    return res
  }

  async print(id) {
    const unixTime = Math.floor(Date.now() / 1000)

    return http({
      url: `/purchase/${id}/print?t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async csv(id) {
    const unixTime = Math.floor(Date.now() / 1000)

    return http({
      url: `/purchase/${id}/csv?t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async recommendation(
    sortField,
    sortOrder,
    supp_id
  ) {
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    const res = await http.get(
      `/purchase/recomendation?sort=${sort}&supp_id=${supp_id}&urgent=0`
    )

    return res.data
  }

  async recommendationPrint(sortField, sortOrder, supp_id) {
    const unixTime = Math.floor(Date.now() / 1000)
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    return http({
      url: `/purchase/recomendation/print?t=${unixTime}&sort=${sort}&supp_id=${supp_id}`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async urgent(
    sortField,
    sortOrder,
    supp_id
  ) {
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    const res = await http.get(
      `/purchase/recomendation?sort=${sort}&supp_id=${supp_id}&urgent=1`
    )

    return res.data
  }

  async urgentPrint(sortField, sortOrder, supp_id) {
    const unixTime = Math.floor(Date.now() / 1000)
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    return http({
      url: `/purchase/recomendation/print?t=${unixTime}&sort=${sort}&supp_id=${supp_id}&urgent=1`,
      method: 'GET',
      responseType: 'blob',
    })
  }

}
